export default __webpack_public_path__ + "static/browser_screenshot-full_page-load-chart-fa9e8a1b6abb6af6edefac234fe6178c.webp";